<template>
  <div class="modal fade" :id="modalId" tabindex="-1" role="dialog"  aria-hidden="true" :ref="modalId">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header text-left">
          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
          <h4 class="modal-title" >
            {{modalState}}
          </h4>
        </div>
        <div class="modal-body" v-if="!combineInfo.length && state != 1">
          <div class="text-red">
            請新增此商品的組合&nbsp;&nbsp;•ᴥ•
          </div>
        </div>
        <div class="modal-body">
          <ul class="nav nav-tabs" style="margin-bottom: 10px;" v-if="state != 1 && combineInfo.length">
            <li role="presentation" v-for="(combine, index) in combineInfo" :class="{active: isTabActive(index + 1)}">
              <a  @click.prevent="clickCombine(combine, index)">{{combine.name}}
                <span v-if="state == 3 && !editState && combine.is_common">&nbsp;<label class="badge bg-blue">常見</label></span>
              </a>
            </li>
            <li class="pull-right" v-if="pageAmount > 1">
              <ul class="pagination" style="margin: 0px">
                <li class="paginate_button" v-for="index in pageAmount" :class="{active: isActive(index)}" @click="getCombineInfo(index)">
                  <a class="c-pointer">{{index}}</a>
                </li>
              </ul>
            </li>
          </ul>
          <div class="text-right" style="margin-right: 10px;" v-if="combineInfo.length">
            <button class="btn btn-danger icon-modal-del inherit" v-if="editState" @click="show.delNotify = !show.delNotify"><i class="fa fa-trash" aria-hidden="true"></i></button>
            <button class="btn btn-primary icon-modal-edit inherit" v-if="!editState && state == 3" @click.prevent="clickEdit()"><i class="fa fa-pencil" aria-hidden="true"></i></button>
            <button class="btn btn-primary icon-modal-edit inherit" v-if="editState" @click.prevent="editState = false"><i class="fa fa-eye" aria-hidden="true"></i></button>
            <div v-if="show.delNotify" class="del-c-block">
              <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                  <div class="modal-header text-left">
                    <h4 class="modal-title">提醒</h4>
                  </div>
                  <div class="modal-body text-left">
                    <p>確定刪除此商品？</p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-default" @click="show.delNotify = false">取消</button>
                    <button type="button" class="btn btn-danger" @click="delCombine">刪除</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- info start-->
          <div class="box-body form" v-if="state == 3 && !editState && page == 1 && combineInfo.length">
            <div>
              <div class="input-group">
                <span class="input-group-addon">組合名稱</span>
                <div class="form-control form-info text-left">{{combineDetail.name}}</div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">商品名稱</span>
                <div class="form-control form-info text-left">{{productName}}</div>
              </div>
              <br />
            </div>
            <div v-if="combineDetail.price">
              <div class="input-group">
                <span class="input-group-addon">價格</span>
                <div class="form-control form-info text-left">{{combineDetail.price}} ({{getPriceType(combineDetail.price_type)}})</div>
              </div>
              <br />
            </div>
            <div v-if="combineDetail.description">
              <div class="input-group">
                <span class="input-group-addon">描述</span>
                <div class="form-control form-info text-left">{{combineDetail.description}}</div>
              </div>
              <br />
            </div>
            <div v-if="combineDetail.remark">
              <div class="input-group">
                <span class="input-group-addon">備註</span>
                <div class="form-control form-info text-left">{{combineDetail.remark}}</div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">組合更新時間</span>
                <div class="form-control form-info text-left">{{combineDetail.update_time}}</div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">組合建立時間</span>
                <div class="form-control form-info text-left">{{combineDetail.create_time}}</div>
              </div>
              <br />
            </div>
          </div>
          <div class="box-body form" v-if="state == 3 && !editState && page == 2" :class="{'form-100-p': page == 2}">
            <div class="col-xs-12 text-left p-x-0">
              <div class="col-xs-12" v-for="(a, index) in isAdjust">
                <div class="text-black col-xs-12 block-adjust-title">
                  <span style="top: 6px;">{{a.name}}&nbsp;<span v-if="a.price">${{a.price}}</span></span>
                </div>
                <div class="text-black col-xs-12">
                  <span class="text-15">{{a.description}} <span v-if="a.remark">({{a.remark}})</span></span>
                </div>
                <div class="card-body col-xs-12">
                  <div class="col-xs-6 col-md-3 p-5" v-for="(o, index) in a.option_list">
                    <button class="btn-options text-16">{{o.name}}&nbsp;<span v-if="o.price">${{o.price}}</span></button>
                  </div>
                </div>
                <span class="col-xs-12">
                    <br>
                  </span>
              </div>
            </div>
            <div class="col-xs-12 text-left p-x-0" v-if="isOption.length">
              <div class="col-xs-12">
                <div class="text-black col-xs-12 block-adjust-title">
                  <span style="top: 6px;">其他選項</span>
                </div>
                <div class="card-body col-xs-12">
                  <div class="col-xs-6 col-md-3 p-5" v-for="(o, index) in isOption">
                    <button class="btn-options text-16">{{o.name}}&nbsp;<span v-if="o.price">${{o.price}}</span></button>
                  </div>
                </div>
                <span class="col-xs-12">
                  <br>
                </span>
              </div>
            </div>
          </div>
          <!-- info end-->
          <!-- form start -->
          <div class="box-body form" v-if="state == 1 || editState" :class="{'form-100-p': page == 2}">
            <div v-show="page == 1">
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>組合名稱</span>
                <input class="form-control" placeholder="" type="text" v-model="combineDetail.name">
                <!--<span class="input-group-addon no-border">組合</span>-->
              </div>
              <br />
              <div>
                <div class="input-group">
                  <span class="input-group-addon">商品名稱</span>
                  <div class="form-control form-info text-left">{{productName}}</div>
                </div>
                <br />
              </div>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>常見價格</span>
                <div class="radio text-left h-38" style="border-left: 1px solid #d2d6de">
                  <label class="m-l-15">
                    <input type="radio" name="commonRadio" value="1" v-model="combineDetail.is_common" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">是</div>
                  </label>
                  <label class="m-l-15">
                    <input type="radio" name="commonRadio" value="0" v-model="combineDetail.is_common" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">否</div>
                  </label>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">價格</span>
                <input class="form-control" placeholder="" type="text" v-model="combineDetail.price" @keyup="verityPrice()" maxlength="9" v-if="state == 1" ref="price1">
                <input class="form-control" placeholder="" type="text" v-model="combineDetail.price" @keyup="verityPrice()" maxlength="9" v-if="state == 3" ref="price3">
              </div>
              <div class="text-right text-15 text-red">(選取組合內的選項皆為此價格)</div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">價格類型</span>
                <div class="form-group">
                  <select class="form-control" v-model="combineDetail.price_type" >
                    <option value="1">免稅價格</option>
                    <option value="3">含稅價格</option>
                  </select>
                </div>
              </div>
              <div class="text-right text-15 text-red">(若無價格則無須更動)</div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">備註</span>
                <input class="form-control" placeholder="" type="text" v-model="combineDetail.remark" maxlength="45">
              </div>
              <br />
            </div>
            <div v-show="page == 2">
              <div class="col-xs-12 text-left p-x-0">
                <div class="col-xs-12" v-for="(a, index) in adjust">
                  <div class="text-black col-xs-12 block-adjust-title">
                    <span style="top: 6px;">{{a.name}}&nbsp; <span v-if="a.price">$ {{a.price}}</span></span>
                    <button class="pull-right btn btn-default text-15 btn-add-product btn-success m-l-15" @click="chooseOptionsByAdjust(a)">全選</button>
                    <button class="pull-right btn btn-default text-15 btn-add-product btn-danger" @click="removeOptionsByAdjust(a)">全取消</button>
                  </div>
                  <div class="text-black col-xs-12">
                    <span class="text-15">{{a.description}} <span v-if="a.remark">({{a.remark}})</span></span>
                  </div>
                  <div class="card-body col-xs-12">
                    <div class="col-xs-6 col-md-3 p-5" v-for="(o, index) in a.option_list">
                      <button class="btn-options text-16" :class="{active: o.tag}">
                        <span @click="chooseOption(o, a)" class="fake-bg"></span>
                        {{o.name}}&nbsp; <span v-if="o.price">$ {{o.price}}</span>
                      </button>
                    </div>
                  </div>
                  <span class="col-xs-12">
                    <br>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <button type="button" class="btn btn-primary m-b-15" v-if="state == 3 && !editState && page == 1 && combineInfo.length" @click="page = 2">組合內容</button>
            <button type="button" class="btn btn-primary m-b-15" v-if="state == 3 && !editState && page == 2 && combineInfo.length" @click="page = 1">組合明細</button>
            <button type="button" class="btn btn-primary" v-if="(state != 3 || editState) && page == 2" @click="page = 1">上一步</button>
            <button type="button" class="btn btn-primary" v-if="(state != 3 || editState) && page == 1" @click="page = 2">下一步</button>
          </div>
          <!-- form end-->
        </div>
        <div class="modal-footer" v-if="state != 3 || editState">
          <button type="button" class="btn btn-default" data-dismiss="modal">返回</button>
          <button type="button" class="btn btn-primary" v-if="state == 1 && page == 2" @click="checkInputEmpty">新增</button>
          <button type="button" class="btn btn-primary" v-if="editState" @click="checkInputEmpty">編輯</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import $ from 'jquery'
export default {
  name: 'CombineModal',
  props: {
    modalId: {
      type: String,
      required: true
    },
    // 1 = add, 2 = edit, 3 = info
    state: {
      type: Number
    },
    productId: {
      type: Number,
      required: true
    },
    productName: {
      type: String
    },
    type: {
      type: String
    }
  },
  data () {
    return {
      editState: false,
      page: 1,
      tabIndex: 1,
      tableIndex: 1,
      adjustIndex: 1,
      count: 20,
      maxTotal: 0,
      maxAdjustTotal: 0,
      show: {
        delNotify: false
      },
      buff: {},
      optionsAmount: {},
      chooseOptions: {},
      adjustNumList: [],
      changePriceList: {},
      isAdjust: [],
      isOption: [],
      isAdjustNumList: [],
      adjust: [],
      option: [],
      combineInfo: {},
      combineDetail: {
        name: '',
        is_common: '0',
        price: '',
        price_type: '3',
        description: '',
        remark: '',
        combine_id: ''
      },
      chosen: {
        adjust: '',
        option: ''
      }
    }
  },
  methods: {
    ...mapActions(['setUpCategory', 'setModal']),
    init () {
      if (typeof this.info !== 'undefined') {
        this.brandName = this.info.name
        this.brandType = this.info.type
      }
    },
    toggle () {
      $(this.$refs.infoCategoryModal).css('display')
    },
    getPriceType (type) {
      if (type === 1) return '免稅價格'
      else if (type === 3) return '含稅價格'
    },
    maxAmount (max) {
      if (!max) return '無限制'
      else return max
    },
    getOption (index) {
      return this.option[index]
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    isTabActive (index) {
      if (this.tabIndex === index) return true
      else return false
    },
    isAdjustActive (index) {
      if (this.adjustIndex === index) return true
      else return false
    },
    getCombineInfo (index) {
      var self = this
      if (index) this.tableIndex = index
      var url = 'brand/' + this.$route.params.brand_id + '/product/' + this.productId + '/combinationlist?page=' + this.tableIndex + '&size=' + this.count
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.combineInfo = response.data.combination_list
          self.maxTotal = response.data.meta.total
          if (self.combineInfo.length) {
            self.clickCombine(self.combineInfo[0], 0)
          }
        }
      })
    },
    clickCombine (combine, index) {
      this.tabIndex = index + 1
      this.getCombineDetail(combine.combine_id)
    },
    getCombineDetail (comId) {
      var self = this
      comId = parseInt(comId, 10)
      var url = 'brand/' + this.$route.params.brand_id + '/combination/' + comId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.combineDetail = response.data.combination
          self.isAdjust = self.combineDetail.adjust_list
          self.isOption = self.combineDetail.option_list
          for (let i = 0; i < self.isAdjust.length; i++) {
            self.isAdjustNumList.push(self.isAdjust[i].adjust_id)
          }
          self.getOptions('info')
        }
      })
    },
    getOptions (type) {
      if (type) {
        if (this.isAdjustNumList.length) {
          for (let i = 0; i < this.isAdjustNumList.length; i++) {
            this.optionByAId(this.isAdjustNumList[i], null, type)
          }
        }
      } else {
        if (this.adjustNumList.length) {
          for (let j = 0; j < this.adjustNumList.length; j++) {
            this.optionByAId(this.adjustNumList[j], null, type)
          }
        }
      }
    },
    optionByAId (adjustId, index, type) {
      var page = 1
      if (index) page = index
      var self = this
      if (adjustId) {
        var url = 'brand/' + this.$route.params.brand_id + '/adjust/' + adjustId + '/optionlist?page=' + page + '&size=' + this.count
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var adjustId = response.data.meta.adjust_id
            var oList = response.data.option_list
            self.optionsAmount[adjustId] = oList.length
            for (let i in oList) {
              oList[i]['tag'] = false
            }
            if (!type) {
              self.adjust.filter(function (elem, index, obj) {
                if (elem.adjust_id === adjustId) {
                  self.$set(elem, 'option_list', oList)
                  self.$set(elem, 'option_total', response.data.meta.total)
                  self.$set(elem, 'page', page)
                }
                return elem.adjust_id === adjustId
              })
            } else {
              // combine info show
              self.isAdjust.filter(function (elem, index, obj) {
                if (elem.adjust_id === adjustId) {
                  self.$set(elem, 'option_list', oList)
                  self.$set(elem, 'option_total', response.data.meta.total)
                  self.$set(elem, 'page', page)
                }
                return elem.adjust_id === adjustId
              })
            }
          }
        })
      }
    },
    clickEdit () {
      this.editState = true
      this.showActiveOption()
    },
    showActiveOption () {
      var self = this
      for (var m in self.adjust) {
        var aa = self.adjust[m]
        for (var n in aa.option_list) {
          aa.option_list[n].tag = false
          for (var k in self.isOption) {
            if (aa.option_list[n].option_id === self.isOption[k].option_id) {
              // console.log(self.isOption[k], aa)
              self.chooseOption(self.isOption[k], aa)
            }
          }
        }
      }
      for (var i in self.isAdjust) {
        var a = self.isAdjust[i]
        for (var j in a.option_list) {
          self.chooseOption(a.option_list[j], a)
        }
      }
      // console.log(this.isOption)
    },
    getAllAdjust (index) {
      var self = this
      if (index) this.adjustIndex = index
      var url = 'brand/' + this.$route.params.brand_id + '/adjust/list?page=' + this.adjustIndex + '&size=' + this.count
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.maxAdjustTotal = response.data.meta.total
          for (let i = 0; i < response.data.adjust_list.length; i++) {
            self.adjust.push(response.data.adjust_list[i])
            self.adjustNumList.push(response.data.adjust_list[i].adjust_id)
            self.chooseOptions[response.data.adjust_list[i].adjust_id] = {
              active_count: 0,
              active_options: []
            }
          }
          if (response.data.adjust_list.length) {
            self.adjustIndex = self.adjustIndex + 1
            self.getAllAdjust(self.adjustIndex)
          } else self.getOptions()
        }
      })
    },
    clearData () {
      this.page = 1
      this.tabIndex = 1
      this.tableIndex = 1
      this.adjustIndex = 1
      this.maxTotal = 0
      this.maxAdjustTotal = 0
      this.show = {
        delNotify: false
      }
      this.buff = {}
      this.optionsAmount = {}
      this.chooseOptions = {}
      this.adjustNumList = []
      this.isAdjust = []
      this.isOption = []
      this.adjust = []
      this.option = []
      this.combineInfo = {}
      this.combineDetail = {
        name: '',
        is_common: '0',
        price: '',
        price_type: '3',
        description: '',
        remark: '',
        combine_id: ''
      }
      this.chosen = {
        adjust: '',
        option: ''
      }
    },
    chooseOption (o, a, allType) {
      // allType = 'all' is all chose, allType = 'remove' is all remove
      var self = this
      // var tag = o.tag
      self.adjust.filter(function (elem, index, obj) {
        if (elem.adjust_id === a.adjust_id) {
          elem.option_list.filter(function (e, i, options) {
            if (e.option_id === o.option_id) {
              if (!o.tag && allType !== 'remove') {
                self.chooseOptions[a.adjust_id]['active_count'] = self.chooseOptions[a.adjust_id]['active_count'] + 1
                self.chooseOptions[a.adjust_id]['active_options'].push(o.option_id)
              } else if (allType === 'all') {
              } else {
                self.chooseOptions[a.adjust_id]['active_count'] = self.chooseOptions[a.adjust_id]['active_count'] - 1
                if (self.chooseOptions[a.adjust_id]['active_options'].length) {
                  let index = self.chooseOptions[a.adjust_id]['active_options'].indexOf(o.option_id)
                  self.chooseOptions[a.adjust_id]['active_options'].splice(index, 1)
                }
                if (self.chooseOptions[a.adjust_id]['active_count'] < 0) self.chooseOptions[a.adjust_id]['active_count'] = 0
              }
              if (allType === 'all') self.$set(e, 'tag', true)
              else if (allType === 'remove') self.$set(e, 'tag', false)
              else self.$set(e, 'tag', !e.tag)
            }
          })
        }
      })
    },
    chooseOptionsByAdjust (a) {
      var self = this
      var optionList = a.option_list
      for (let i in optionList) {
        let o = optionList[i]
        self.chooseOption(o, a, 'all')
      }
    },
    removeOptionsByAdjust (a) {
      var self = this
      var optionList = a.option_list
      for (let i in optionList) {
        let o = optionList[i]
        self.chooseOption(o, a, 'remove')
      }
    },
    checkInputEmpty () {
      if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫組合名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.pickChosen()
      }
    },
    pickChosen () {
      this.chosen = {
        adjust: [],
        option: []
      }
      var self = this
      for (var i in this.chooseOptions) {
        if (self.chooseOptions[i].active_count === self.optionsAmount[i]) {
          self.chosen.adjust.push(i + '/')
        } else if (self.chooseOptions[i].active_count !== 0) {
          // console.log(self.chooseOptions[i].active_options)
          for (let j = 0; j < self.chooseOptions[i].active_options.length; j++) {
            self.chosen.option.push(self.chooseOptions[i].active_options[j] + '/')
          }
        }
      }
      if (!this.chosen.adjust.length && !this.chosen.option.length) {
        this.$notify({
          title: '提醒',
          text: '請選擇此商品的組合選項',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        // console.log(this.chosen)
        this.updateCombine()
      }
    },
    updateCombine () {
      var self = this
      var url = 'brand/' + this.$route.params.brand_id + '/combination'
      var data = {
        product_id: this.productId,
        name: this.allInput.name,
        price: this.allInput.price,
        price_type: this.combineDetail.price_type,
        is_common: this.combineDetail.is_common,
        adjust: this.chosen.adjust,
        option: this.chosen.option
      }
      if (!data.price.length) data.price = null
      if (this.combineDetail.combine_id) data['combine_id'] = this.combineDetail.combine_id
      if (this.allInput.remark) data['remark'] = this.allInput.remark
      // console.log(data)
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功新增組合',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.editState = false
          var id = self.modalId
          $('#' + id).modal('toggle')
        }
      })
    },
    getPrice (price) {
      return price
    },
    verityPrice () {
      var e
      if (this.state === 1) e = $(this.$refs.price1)
      else if (this.state === 3) e = $(this.$refs.price3)
      this.combineDetail.price = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    delCombine () {
      var self = this
      var url = 'brand/' + this.$route.params.brand_id + '/combination?combine_id=' + this.combineDetail.combine_id
      // console.log(url)
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功刪除組合',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.editState = false
          var id = self.modalId
          $('#' + id).modal('toggle')
          self.setUpCategory(true)
        }
      })
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapGetters(['getModal']),
    modalState () {
      if (this.state === 3 && !this.editState) return this.productName + '組合'
      if (this.editState) return '編輯' + '一般組合'
      else return '新增組合'
    },
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    },
    allInput () {
      return {
        name: this.checkInput(this.combineDetail.name),
        description: this.checkInput(this.combineDetail.description),
        remark: this.checkInput(this.combineDetail.remark),
        price: this.checkInput(this.combineDetail.price)
      }
    },
    pageAmount () {
      return Math.ceil(this.maxTotal / this.count)
    }
  },
  mounted () {
    var self = this
    $('.modal').on('hidden.bs.modal', function () {
      self.setModal(false)
      self.clearData()
    })
  },
  watch: {
    getModal () {
      if (this.getModal) {
        this.page = 1
        this.editState = false
        this.show.delNotify = false
        if (this.type === 'info') {
          this.getCombineInfo()
        }
        this.getAllAdjust()
      }
    }
  }
}
</script>
<style lang="sass">
  $default-color: #e1456d
  $light-gray: rgb(238, 238, 238)
  .fake-bg
    position: absolute
    top: 0px
    left: 0px
    width: 100%
    height: 100%
  .btn-options.active
    background: $default-color
    color: white
  input[type=checkbox], input[type=radio]
    margin: 0px
  .text-light-gray
    color: $light-gray !important
  .checkbox, .radio
    margin: 0px
  .m-l-15
    margin-left: 15px
  .form.form-100-p
    width: 100%
    left: 0
  .btn-success, .btn-danger
    color: #ffffff
  .p-5
    padding: 5px
  .text-16
    font-size: 16px !important
  .m-b-15
    margin-bottom: 15px !important
</style>
<style lang="sass" scoped>
  .block-adjust-title
    margin-bottom: 10px
  .text-16.btn-options
    padding: 6px !important
  .icon-modal-edit.inherit, .icon-modal-del.inherit
    position: relative
    top: inherit
    right: inherit
  .icon-modal-edit.inherit
    margin-left: 10px
</style>



// WEBPACK FOOTER //
// CombineModal.vue?9e3be7f2